import { Component } from '@angular/core'
import { CheckinComponent } from '@monorepo-channels/components/feature-porto-bank'

@Component({
	standalone: true,
	selector: 'porto-bank-checkin-page',
	imports: [CheckinComponent],
	template: '<feature-porto-bank-checkin></feature-porto-bank-checkin>',
})
export class CheckinPageComponent {}
